import script from "./Company.vue?vue&type=script&setup=true&lang=js"
export * from "./Company.vue?vue&type=script&setup=true&lang=js"

import "./Company.vue?vue&type=style&index=0&id=261981a8&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-261981a8"]])

export default __exports__